import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';
import type { PaginatedLaporanTahunanResponse } from './type';
import { useLocale } from '@/app/[lang]/providers/LocaleProvider';

export function useLaporanTahunan(year?: number, month?: number, page = 1) {
  const lang = useLocale();
  
  return useQuery<PaginatedLaporanTahunanResponse>({
    queryKey: ['laporan-tahunan', lang, year, month, page],
    enabled: true,
    queryFn: async () => {
      const params = new URLSearchParams({ lang, sort: '-published_at', page: page.toString() });
      
      if (year !== undefined) {
        params.append('year', year.toString());
      }
      
      if (month !== undefined) {
        params.append('month', month.toString());
      }
      
      const res = await http.get(`/api/laporan-tahunans?${params.toString()}`);
      return res.data;
    },
  });
}
